import cloneDeep from "lodash/cloneDeep";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Node } from "./helpers";
import css from "./skills_explorer.module.scss";

type BreadcrumbProps = {
  skills: Node[];
  path: number[];
  setPath: (path: number[]) => void;
};

type ToReturn = {
  name: string;
  path: number[];
}[];

export const Breadcrumb = ({ skills, path, setPath }: BreadcrumbProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts" });

  const displayPath = useMemo(() => {
    const toReturn: ToReturn = [{ name: t("charts.allSkills"), path: [] }];
    let skillsCopy = cloneDeep(skills);

    path.forEach((dataIndex, index) => {
      if (skillsCopy[dataIndex]) {
        toReturn.push({ name: skillsCopy[dataIndex].name || "", path: path.slice(0, index + 1) });
      }
      if (skillsCopy[dataIndex]?.children) {
        skillsCopy = skillsCopy[dataIndex]?.children;
      }
    });

    return toReturn;
  }, [path, skills, t]);

  return (
    <ul className={css.breadcrumb}>
      {displayPath.map((item, index) => (
        <li key={`breadcrumb_${index}`}>
          <button onClick={() => setPath(item.path)}>{item.name}</button>
        </li>
      ))}
    </ul>
  );
};
